module.exports = __webpack_public_path__ + "static/media/website-02.e58e1094.mp4";